'use client';

import Link from 'next/link';
import { IoArrowBack, IoSearch } from 'react-icons/io5';

import Logo from '@/components/layout/Logo';

const RotatedSquaresBg = () => (
  <div
    aria-hidden
    className="pointer-events-none absolute inset-0 overflow-hidden z-0"
  >
    <div className="absolute left-1/2 -translate-x-1/2 top-10 sm:-top-10 md:-top-16 w-[500px] sm:w-[700px] md:w-[820px] lg:w-[900px] opacity-50 sm:opacity-70 md:opacity-100">
      <svg
        viewBox="0 0 909 655"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-auto"
      >
        <rect x="397.504" y="163.907" width="95" height="95" rx="19.5" transform="rotate(-12.5 397.504 163.907)" stroke="#E9EAEB" />
        <rect x="340.254" y="127.434" width="191" height="191" rx="19.5" transform="rotate(-12.5 340.254 127.434)" stroke="#E9EAEB" />
        <rect x="283.002" y="90.961" width="287" height="287" rx="19.5" transform="rotate(-12.5 283.002 90.961)" stroke="#E9EAEB" />
        <rect x="225.75" y="54.4874" width="383" height="383" rx="19.5" transform="rotate(-12.5 225.75 54.4874)" stroke="#E9EAEB" />
        <rect x="168.5" y="18.0147" width="479" height="479" rx="19.5" transform="rotate(-12.5 168.5 18.0147)" stroke="#E9EAEB" />
        <rect x="111.248" y="-18.4587" width="575" height="575" rx="19.5" transform="rotate(-12.5 111.248 -18.4587)" stroke="#E9EAEB" />
        <rect x="53.9958" y="-54.9316" width="671" height="671" rx="19.5" transform="rotate(-12.5 53.9958 -54.9316)" stroke="#E9EAEB" />
        <rect x="-3.25422" y="-91.4052" width="767" height="767" rx="19.5" transform="rotate(-12.5 -3.25422 -91.4052)" stroke="#E9EAEB" />
      </svg>
    </div>
  </div>
);

export default function NotFoundContent() {
  return (
    <div
      className="w-full min-h-[calc(100vh-260px)] flex items-center overflow-hidden relative"
      style={{ backgroundColor: 'var(--color-background)' }}
    >
      <RotatedSquaresBg />
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 sm:px-12 flex flex-col md:flex-row items-center justify-between gap-12 py-16">
        <div className="flex-1 flex flex-col items-start gap-6">
          <span
            className="font-bold text-lg tracking-wide"
            style={{ color: 'var(--color-primary)' }}
          >
            404 error
          </span>
          <h1
            className="text-5xl sm:text-6xl font-extrabold leading-tight"
            style={{ color: 'var(--color-foreground)' }}
          >
            Page not found
          </h1>
          <p className="text-lg sm:text-xl leading-relaxed max-w-md opacity-70" style={{ color: 'var(--color-foreground)' }}>
            Sorry, the page you are looking for doesn&apos;t exist or has been moved.
          </p>
          <div className="flex items-center gap-4 mt-2">
            <button
              type="button"
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-2 font-bold px-6 py-2 border"
              style={{ borderColor: 'var(--color-primary)', color: 'var(--color-primary)' }}
            >
              <IoArrowBack /> Go back
            </button>
            <Link
              href="/"
              className="inline-flex items-center font-bold px-6 py-2 text-white"
              style={{ backgroundColor: 'var(--color-primary)' }}
            >
              Take me home
            </Link>
          </div>
        </div>

        <div className="flex-1 flex items-center justify-center">
          <div className="relative w-[300px] h-[300px] sm:w-[400px] sm:h-[400px]">
            <div className="absolute inset-0 rounded-full border border-[#E9EAEB] bg-gradient-to-br from-[#F8F9FA] to-white shadow-xl" />
            <div className="absolute inset-[40px] rounded-full border border-[#E9EAEB] bg-gradient-to-br from-white to-[#F1F3F5] shadow-lg" />
            <div className="absolute inset-[80px] rounded-full border border-[#E9EAEB] bg-white shadow-md" />
            <div className="absolute bottom-[55px] right-[55px] w-20 h-20 rounded-full shadow-lg flex items-center justify-center" style={{ backgroundColor: 'var(--color-primary)' }}>
              <IoSearch className="text-white text-3xl" />
            </div>
            <div className="absolute top-[28px] right-[18px] w-5 h-5 rounded-full bg-[#E9EAEB]" />
            <div className="absolute top-[58px] right-[-2px] w-3 h-3 rounded-full bg-[#E9EAEB]" />
            <div className="absolute bottom-[38px] left-[8px] w-4 h-4 rounded-full bg-[#E9EAEB]" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="relative w-40 opacity-10">
                <Logo priority={false} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
